import { createFileRoute } from '@tanstack/react-router';

import { getSupportTicketsQueryOptions, SupportTicketDetailsLoading } from '@/_containers/support';
import { getCompanyQueryOptions } from '@/_pages/companies/api-service';

export const Route = createFileRoute('/_private/companies/_template/$id/support/$ticket_id')({
  loader: async (opts) => {
    const companyData = await opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id));
    await opts.context.queryClient.ensureQueryData(
      getSupportTicketsQueryOptions({ companyId: companyData.data.freshdesk?.toString() || '' })
    );
  },
  staticData: {
    pageTitle: 'Ticket Details',
    tabKey: 'client/support/details',
    renderRightColumn: true,
    isViewOnly: true,
  },
  pendingComponent: SupportTicketDetailsLoading,
});
